import {
    COLOR_BLACK,
    COLOR_SECONDARY,
    COLOR_SUCCESS,
    COLOR_SUCCESS_ACTIVE,
    COLOR_WARNING_STRONG,
    COLOR_WARNING_STRONG_ACTIVE,
} from "./constants/Colors";
import {OrderDTO, OrderStatus} from "../types/order/OrderDTO";
import {MINUTE} from "./constants/Texts";
import {BranchDTO} from "../types/branch/BranchDTO";


export type ColorStatus = {
    inactive: string,
    active: string
}
export const findColorByStatus = (status: OrderStatus): ColorStatus => {
    switch (status) {
        case "WaitCooking":
        case "ReadyForCooking":
            return {inactive: COLOR_SECONDARY, active: COLOR_BLACK}
        case "CookingStarted":
            return {inactive: COLOR_WARNING_STRONG, active: COLOR_WARNING_STRONG_ACTIVE}
        case "CookingCompleted":
            return {inactive: COLOR_SUCCESS, active: COLOR_SUCCESS_ACTIVE}
        default:
            return {inactive: COLOR_SECONDARY, active: COLOR_BLACK}
    }
}
export const dateDiffInMinutes = (dateOne: Date, dateTwo: Date): string => {
    return `${Math.round((dateOne.getTime() - dateTwo.getTime()) / 60_000)} ${MINUTE}`;
}

export const findOutCompletionTime = (completeBefore: string | null | undefined): string => {
    if (!completeBefore) return "-"
    return dateDiffInMinutes(new Date(completeBefore), new Date())
}
export const findOutWhenDelayedTime = (
    whenDelayed: string,
    completeBefore: string
): string => {
    if (!completeBefore && !whenDelayed) return "-";
    return dateDiffInMinutes(new Date(completeBefore), new Date(whenDelayed));
};
export const checkTimeDifference = (order: OrderDTO, orders: OrderDTO[], branch: BranchDTO | null | undefined): boolean => {
    const times = orders.map(item => item.cookingStartTime).filter(item => item !== null)
    if (times.length === 0) {
        return false
    }

    if (!order.cookingStartTime) {
        return false
    }

    const deltaTimes =
        (branch?.deltaMinutesBetweenDeliveries ?? (process.env.REACT_APP_DELTA_MINUTES as unknown as number)) * 60_000

    const timeInSeconds = new Date(order.cookingStartTime).getTime()
    for (let i = 0; i < times.length; i++) {
        if (
            Math.abs(timeInSeconds - new Date(times[i]!!).getTime()) > deltaTimes) {
            return false
        }
    }

    return true
}


export const secondsToMinute = (seconds: number): string => {
    return (Math.round(seconds / 60)) + "\t" + MINUTE
}

export const lastSecondsToTime = (startTime: number | null | undefined, seconds: number): string => new Date((startTime ?? new Date().getTime()) - seconds * 1000).toTimeString().slice(0, 5)

export const humanizeDateTimeToMinutes = (dateTime: string | undefined): string => dateTime ? new Date(dateTime).toTimeString().slice(0, 5) : ""

export const humanizeDateTimeDifference = (dateTime: string | undefined): string =>
    dateTime ? dateDiffInMinutes(new Date(), new Date(dateTime)) : ""

export function useLocalStorage<T>(key: string): {
    value: T | null | undefined,
    setValue: (value: T | null | undefined) => void
} {
    const item = localStorage.getItem(key)
    return {
        value: item ? JSON.parse(item) : undefined,
        setValue: (value) => value && localStorage.setItem(key, JSON.stringify(value))
    }
}

export function toggleList<T>(list: T[], items: T[] | undefined, has: boolean): T[] {
    return items ? has
        ? remove(list, items)
        : add(list, items) : list
}

export function remove<T>(list: T[], items: T[]): T[] {
    return list.filter(it => !items.includes(it))
}

export function add<T>(list: T[], items: T[]): T[] {
    return [...list, ...items]
}

export const getMaxLimitForCouriers = (branch: BranchDTO | null | undefined): number => {
    return branch?.maxLimitForCouriers ? branch?.maxLimitForCouriers :
        process.env.REACT_APP_MAX_ORDER_PER_COURIER ? (process.env.REACT_APP_MAX_ORDER_PER_COURIER as unknown as number) : 0
}

export const format = (text: string, arg: string): string => {
    return text.replace("%s", arg)
}